var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 10.25V12.5H36H35.25V8V5.75H40.5V10.25Z",
    fill: "#FF8B3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 10.25V17H40.5V12.5V10.25H45.75Z",
    fill: "#84C70D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 17V43.25H36L40.5 38.75V17H45.75Z",
    fill: "#699914"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 43.25L41.25 47.75H12.75V43.25H36H45.75Z",
    fill: "#84C70D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 38.75L36 43.25H12.75H7.5V38.75H30.75H40.5Z",
    fill: "#FF8B3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 17V38.75H30.75L35.25 34.25V12.5H36H40.5V17Z",
    fill: "#D9772F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 34.25L30.75 38.75H7.5H2.25V32H6.75L9 34.25H18.75H35.25Z",
    fill: "#84C70D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 5.75L6 12.5V27.5L18.75 34.25H9L6.75 32H2.25V5.75H18.75Z",
    fill: "#699914"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 5.75V8H30.75L28.5 5.75H18.75H2.25L6.75 1.25H35.25V5.75Z",
    fill: "#84C70D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 12.5V34.25H18.75L31.5 27.5V12.5L18.75 5.75H28.5L30.75 8H35.25V12.5Z",
    fill: "#699914"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 12.5V27.5L18.75 34.25L6 27.5V12.5L18.75 5.75L31.5 12.5ZM26.25 24.3425V15.6575L21 12.86C21 11.615 19.995 10.61 18.75 10.61C17.505 10.61 16.5 11.615 16.5 12.86L11.25 15.6575V24.3425L16.5 27.14C16.5 28.385 17.505 29.39 18.75 29.39C19.995 29.39 21 28.385 21 27.14L26.25 24.3425Z",
    fill: "#FFCC3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.1104C19.9926 15.1104 21 14.103 21 12.8604C21 11.6177 19.9926 10.6104 18.75 10.6104C17.5074 10.6104 16.5 11.6177 16.5 12.8604C16.5 14.103 17.5074 15.1104 18.75 15.1104Z",
    fill: "#FF8B3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.8604L26.25 15.6579V24.3429L21 27.1404C21 25.9029 19.995 24.8904 18.75 24.8904C17.505 24.8904 16.5 25.9029 16.5 27.1404L11.25 24.3429V15.6579L16.5 12.8604C16.5 14.0979 17.505 15.1104 18.75 15.1104C19.995 15.1104 21 14.0979 21 12.8604Z",
    fill: "#F7A539"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 29.3896C19.9926 29.3896 21 28.3823 21 27.1396C21 25.897 19.9926 24.8896 18.75 24.8896C17.5074 24.8896 16.5 25.897 16.5 27.1396C16.5 28.3823 17.5074 29.3896 18.75 29.3896Z",
    fill: "#FF8B3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.c1d2fa2f6eb9012b841844065a1de889.svg";
export { ForwardRef as ReactComponent };